import {MODE_TYPE} from "utils/constants";

export const changeMode = mode => ({
  type: MODE_TYPE.CHANGE_MODE,
  payload: mode,
});

export const changePublishMode = mode => ({
  type: MODE_TYPE.CHANGE_PUBLISH_MODE,
  payload: mode,
});
